<div class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="modalTitle" style="display: block;" aria-modal="true">
  <div class="modal-dialog modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalTitle">
          Transaction detail
        </h4>
        <button type="button" class="close" (click)="close()" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">


        <p *ngIf="HoldBy">
          <b><u>Hold Details</u></b><br>
          Held By: {{HoldByUser.email}}<br>
          Held At: <span [innerHTML]="HoldAt | date"></span><br>
          Reason: <span [innerHTML]="HoldReason"></span><br>
        </p>

        <p *ngIf="ReleaseBy">
          <b><u>Release Details</u></b><br>
          Held By: {{ReleaseByUser.email}}<br>
          Held At: <span [innerHTML]="ReleaseAt | date"></span><br>
          Reason: <span [innerHTML]="ReleaseReason"></span><br>
        </p>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>
